<p-button [label]="label()" [severity]="severity()" [styleClass]="rawStyleClass()" [size]="size()" [rounded]="rounded()"
  [class]="class()" [routerLink]="link() || null" [fluid]="fluid()" [iconPos]="customIcon().pos ?? 'right'" [style]="{
    'background-color': bgColor(),
    'border-color': borderColor(),
    color: textColor(),
  }">
  @if (customIcon().src) {
  @if (customIcon().pos === 'left') {
  <ng-template pTemplate="icon">
    <img [src]="customIcon().src" [alt]="customIcon().alt" [class]="customIcon().class" />
  </ng-template>
  }
  <ng-template pTemplate="content">
    <span>{{ label() }}</span>
  </ng-template>
  @if (customIcon().pos === 'right') {
  <ng-template pTemplate="icon">
    <img [src]="customIcon().src" [alt]="customIcon().alt" [class]="customIcon().class" loading="lazy" />
  </ng-template>
  }
  } @else {
  <ng-template pTemplate="content">
    <span>{{ label() }}</span>
  </ng-template>
  }
</p-button>